import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatExtractedValue',
  standalone: true,
})
export class FormatExtractedValuePipe implements PipeTransform {
  private datePipe = new DatePipe('it-IT');

  transform(value: any): string {
    if (value === null || value === undefined || value === '—') {
      return '—';
    }

    // Check if it's a date (yyyy-mm-dd format or Date object)
    if (this.isDate(value)) {
      return this.formatDate(value);
    }

    // Check if it's a number value
    if (this.isNumber(value)) {
      return this.formatNumber(value);
    }

    // Return as string for regular values
    if (Array.isArray(value)) {
      return value.join(', ');
    }
    return String(value);
  }

  private isDate(value: any): boolean {
    // If it's already a Date object
    if (value instanceof Date) {
      console.log('Date object:', value);
      return !isNaN(value.getTime());
    }

    // If it's a string, check for yyyy-mm-dd format
    if (typeof value === 'string') {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(value)) {
        return false;
      }

      // Validate it's a real date
      const date = new Date(value);
      return !isNaN(date.getTime());
    }

    return false;
  }

  private formatDate(value: any): string {
    // Use Angular's DatePipe with Italian format (dd/MM/yyyy)
    const formatted = this.datePipe.transform(value, 'dd/MM/yyyy');
    return formatted || String(value);
  }

  private isNumber(value: any): boolean {
    // Only format actual number types as currency, not strings
    if (typeof value === 'number' && !isNaN(value)) {
      return true;
    }

    return false;
  }

  private formatNumber(value: any): string {
    const numValue = typeof value === 'number' ? value : parseFloat(value);

    if (isNaN(numValue)) {
      return String(value);
    }

    // Format with Italian locale (. for thousands, , for decimals)
    if (numValue == 0) {
      return '0';
    }
    const formatted = new Intl.NumberFormat('it-IT', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(Math.abs(numValue));

    // Add € symbol and handle negative values
    if (numValue < 0) {
      return `- ${formatted}`;
    } else {
      return `${formatted}`;
    }
  }
}
